module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_3016.63bd18f8.png";